import { useSelector } from "react-redux";

const useGuest = () => {
  const user = useSelector((state) => state.user);
  return !user?.authenticated;
};

export default useGuest;
